module.exports = __webpack_public_path__ + "media/images/gallery/constellations/crater/crt_vis-fb53afe69df1d68bb54cd6218c2d02fc.jpg";